module.exports = __webpack_public_path__ + "static/media/resize.8d05ff61.mp4";